import { useEffect } from 'react';
import { X, Download, FileText } from 'lucide-react';

interface DocumentViewerProps {
  isOpen: boolean;
  onClose: () => void;
  url: string | undefined;
  title: string;
}

export default function DocumentViewer({ isOpen, onClose, url, title }: DocumentViewerProps) {

  useEffect(() => {
    return () => {
      if (url?.startsWith('blob:')) {
        window.URL.revokeObjectURL(url);
      }
    };
  }, [url]);

  if (!isOpen || !url) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/90 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white w-full max-w-5xl h-[90vh] rounded-3xl overflow-hidden shadow-2xl flex flex-col animate-in zoom-in-95 duration-300">
        
        {/* Header */}
        <div className="p-4 border-b border-slate-100 flex items-center justify-between bg-slate-50">
          <div className="flex items-center gap-4">
            <div className="bg-slate-900 p-2 rounded-xl text-white shadow-lg shadow-slate-200">
              <FileText className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-black text-slate-900 leading-none truncate max-w-[200px] sm:max-w-md">{title}</h3>
              <p className="text-[10px] text-slate-400 font-bold uppercase mt-1 tracking-wider">Aperçu du document</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <a 
              href={url}
              download={title} 
              className="p-2.5 bg-white border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition shadow-sm flex items-center gap-2 text-sm font-bold"
            >
              <Download className="w-4 h-4" />
              <span className="hidden sm:inline">Télécharger</span>
            </a>
            <button 
              onClick={onClose} 
              className="p-2.5 bg-slate-200 text-slate-600 rounded-xl hover:bg-red-500 hover:text-white transition shadow-sm"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 bg-slate-100 p-4 sm:p-8 overflow-hidden">
          <iframe
            src={`${url}#toolbar=0&navpanes=0`} 
            className="w-full h-full rounded-xl bg-white shadow-inner border border-slate-200"
            title={title}
          />
        </div>
      </div>
    </div>
  );
}
